import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listCustomerMetaData } from './api';
import {
  LIST_CUSTOMER_METADATA_SUCCESS,
  LIST_CUSTOMER_METADATA_REQUEST,
  CUSTOMER_METADATA_LIST_REQUESTING,
  RESET_CUSTOMER_METADATA_ISFETCHING
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_METADATA_LIST_REQUESTING });
    const response = yield call(listCustomerMetaData);
    yield put({ type: LIST_CUSTOMER_METADATA_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_METADATA_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_CUSTOMER_METADATA_REQUEST, list);
}

export default function* customeMetaDataSagas() {
  yield all([watchList()]);
}
